const nimKickedCacheKey = '@fett/nimKicked';

export type LogoutType =
  | 'kicked'
  | 'changePassword-n'
  | 'stopService'
  | 'userLogout'
  | 'unAuthorize';

export const record = (logoutType: LogoutType) => {
  localStorage.setItem(nimKickedCacheKey, logoutType);
};

export const clear = () => {
  localStorage.removeItem(nimKickedCacheKey);
};

export const isKicked = () => {
  const value = localStorage.getItem(nimKickedCacheKey);
  return value === 'kicked';
};

export const isChangePassword = () => {
  const value = localStorage.getItem(nimKickedCacheKey);
  return value === 'changePassword-n';
};

export const isStopService = () => {
  const value = localStorage.getItem(nimKickedCacheKey);
  return value === 'stopService';
};
